import { FastField } from 'formik';
import FormTextField from '../../common/form/FormTextField';
import DatePicker from '../../common/form/DatePicker';
import TimePicker from '../../common/form/TimePicker';
import CommonSelectField from '../../common/form/CommonSelectField';
import CommonCheckbox from '../../common/form/CommonCheckbox';
import React, { useState } from 'react';
import {
  ACCOUNT_NUMBER_FIELD_TYPE,
  BOOLEAN_FIELD_TYPE,
  CODE_FIELD_TYPE,
  COLOR_FIELD_TYPE,
  DATE_FIELD_TYPE,
  DATE_TIME_FIELD_TYPE,
  DAY_FIELD_TYPE,
  DICTIONARY_FIELD_TYPE,
  MULTI_SELECT_FIELD_TYPE,
  NUMBER_FIELD_TYPE, PHONE_NUMBER_FIELD_TYPE,
  PRICE_UNIT_FIELD_TYPE,
  SELECT_FIELD_TYPE,
  STRING_FIELD_TYPE,
  TIME_FIELD_TYPE,
  VAT_FIELD_TYPE,
} from '../../../utils/form-utils';
import { DAY_OPTIONS, NOT_SPECIFIED } from '../../../utils/dates-const';
import { PRICE_UNIT_OPTIONS } from '../../../utils/adminstration-items-const';
import ColorPicker from '../../common/form/ColorPicker';
import { DEFAULT_COLOR } from '../../../const/color-picker-const';
import FieldWithTooltip from '../../common/form/FieldWithTooltip';
import { IconButton, Typography } from '@material-ui/core';
import { Autorenew, ExpandMore } from '@material-ui/icons';
import { getRandom8NumbersCode } from '../../../actions/utils';
import Switch from '@material-ui/core/Switch/Switch';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import RenderBreakpoint from '../../common/breakpoints/RenderBreakpoint';
import classNames from 'classnames';
import CommonMultiSelectField from '../../common/form/CommonMultiSelectField';

export const ADMINISTRATION_DATA_TYPE =
  {
    INVENTORY_TABLE: 'InventoryItem',
    CATEGORY_TABLE: 'Category',
    BONG_CATEGORY_TABLE: 'BongCategory',
    CUSTOMER_TABLE: 'Customer',
    DICTIONARY_WORD_TABLE: 'DictionaryWord',
    GIFT_CARD_TABLE: 'GiftCard',
    SCHEDULE_TIME_TABLE: 'ScheduleTimeType',
    ACCOUNT_TABLE: 'Account',
  };

const FIELDS_PER_ROW = 4;

export function sliceRows(fields) {
  let rowsFields = [];
  for (let i = 0; i < fields.length; i += FIELDS_PER_ROW) {
    const slicedOptions = fields.slice(i, i + FIELDS_PER_ROW);
    rowsFields = [...rowsFields, slicedOptions];
  }
  
  return rowsFields;
}

export function getDefaultValueForFieldType(fieldType) {
  switch (fieldType) {
    case STRING_FIELD_TYPE:
      return '';
    case NUMBER_FIELD_TYPE:
      return null;
    case ACCOUNT_NUMBER_FIELD_TYPE:
      return null;
    case COLOR_FIELD_TYPE:
      return DEFAULT_COLOR;
    case  DAY_FIELD_TYPE:
      return NOT_SPECIFIED.value;
    case  DATE_FIELD_TYPE:
      return null;
    case  DATE_TIME_FIELD_TYPE:
      return null;
    case  TIME_FIELD_TYPE:
      return null;
    case  BOOLEAN_FIELD_TYPE:
      return false;
    case  SELECT_FIELD_TYPE:
      return '';
    case  MULTI_SELECT_FIELD_TYPE:
      return '';
    case  PRICE_UNIT_OPTIONS:
      return '';
    default:
      return null;
  }
  
}

const setBarOrProductCodeValue = (values, name, setFieldValue) => {
  const { BarCode, ProductCode } = values;
  const generatedCode = getRandom8NumbersCode();
  
  if ([ProductCode, BarCode].some(i => i === null)) {
    setFieldValue('ProductCode', generatedCode);
    setFieldValue('BarCode', generatedCode);
  }
  
  return setFieldValue(name, generatedCode);
};

const ListDataCategories = ['ParentCategoryName', 'ParentCategories', 'BongCategories'];
const setListDataOptionsForSelectFieldType = (field, administrationListData, values) => {
  if (field.options) return field.options;
  
  const filteredData = (field.name === 'ParentCategoryName')
    ? administrationListData.ParentCategories
    : administrationListData[field.name];
  
  const excludeParent = ('ParentCategories' in administrationListData);
  const filtered = (item) => excludeParent ? (item.Value !== values.Name) : (item.Value);
  
  return filteredData && filteredData
    .filter(item => filtered(item))
    .map(data => ({
      value: data.Value,
      label: data.Value,
    }));
};

const setVatValue = (CategoryName, administrationExtraData, setFieldValue) => {
  if (CategoryName && administrationExtraData?.CategoryName) {
    let [filtered] = administrationExtraData.CategoryName.filter(item => item.Value === CategoryName);
    
    if (filtered) {
      return setFieldValue('VatPercentage', filtered?.VAT);
    }
  }
  setFieldValue('VatPercentage', 0);
};

const setExtraDataOptionsForSelectFieldType = (field, administrationExtraData) => {
  if (field.options) return field.options;
  
  const data = administrationExtraData[field.name] || [];
  switch (field.name) {
    case 'SpecialFunctionType':
    case 'SpecialFunctionTypeId':
      return data && data?.map(({ Id, Value }) => ({ value: Id, label: Value }));
    case 'PriceCalculationType':
      return data && data?.map(({ Id, Value }) => ({ value: Id, label: Value }));
    default:
      return data && data?.map(({ Value }) => ({ value: Value, label: Value }));
  }
};

const resetAccountNumberFields = (setFieldValue) => {
  setFieldValue('AccountNumber', null);
  setFieldValue('HasAccountNumber', false);
};

const useStyles = makeStyles({
  accountNumberWrapper: {
    minWidth: 220,
    display: 'flex',
    alignItems: 'center',
  },
});

const AdministrationItemsFormFields = ({
                                         values,
                                         rows,
                                         classes,
                                         administrationExtraData,
                                         administrationListData,
                                         setFieldValue,
                                         isUpdate,
                                         vatOptions,
                                         dictionaries,
                                         setDirty,
                                         itemIndex, accordion, setAccordion,
                                       }) => {
  
  const [useStandardAccount, setUseStandardAccount] = useState(!values.AccountNumber);
  const styles = useStyles();
  
  const { CategoryName } = values;
  React.useEffect(() => {
    setVatValue(CategoryName, administrationExtraData, setFieldValue);
  }, [CategoryName, administrationExtraData, setFieldValue]);
  
  const isOpened = (itemIndex) => accordion.includes(itemIndex);
  
  const handleAccordion = (itemIndex) => {
    if (isOpened(itemIndex)) {
      const filteredAccordion = accordion.filter((idx) => idx !== itemIndex);
      return setAccordion(filteredAccordion);
    }
    return setAccordion(accordion => [...accordion, itemIndex]);
  };
  
  const renderExpandIcon = () => {
    return <>
      {accordion && <ExpandMore onClick={() => handleAccordion(itemIndex)}
                                className={classNames(classes.accordionArrow,
                                  isOpened(itemIndex) && classes.accordionOpened)} />}
    </>;
  };
  
  return (
    rows.map((row, index) => {
      return (<div key={index} className={classes.sectionWrapper}>
        {<RenderBreakpoint mobile>
          {index === 0 && renderExpandIcon()}
        </RenderBreakpoint>}
        {/*eslint-disable-next-line array-callback-return*/}
        {row.map((field, index2) => {
          // eslint-disable-next-line default-case
          switch (field.type) {
            case STRING_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  disabled={field.disabled || (isUpdate && field.disabledOnUpdate)}
                  variant="standard"
                  name={field.name}
                  component={FormTextField}
                  label={field.label}
                  multiline={field.multiline}
                  validate={field.validate}
                  setDirty={setDirty}
                />}
              />;
            case NUMBER_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  disabled={field.disabled || (isUpdate && field.disabledOnUpdate)}
                  variant="standard"
                  type="number"
                  name={field.name}
                  component={FormTextField}
                  label={field.label}
                  validate={field.validate}
                  setDirty={setDirty}
                />}
              />;
            case PHONE_NUMBER_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  disabled={field.disabled || (isUpdate && field.disabledOnUpdate)}
                  variant="standard"
                  type="text"
                  name={field.name}
                  component={FormTextField}
                  label={field.label}
                  validate={field.validate}
                  setDirty={setDirty}
                />}
              />;
            case ACCOUNT_NUMBER_FIELD_TYPE:
              return <Box key={index2}>
                <div className={`${styles.accountNumberWrapper} accountNumberWrapper`}>
                  <Switch color="primary" checked={useStandardAccount}
                          onChange={() => {
                            setUseStandardAccount(!useStandardAccount);
                            if (resetAccountNumberFields) resetAccountNumberFields(setFieldValue);
                          }} />
                  <Typography> <FormattedMessage
                    id="administration.field.useStandardAccount"
                    defaultMessage="Use standard account" /></Typography>
                </div>
                {!useStandardAccount &&
                <FieldWithTooltip
                  helperText={field.helperText}
                  formField={<FastField
                    disabled={field.disabled || (isUpdate && field.disabledOnUpdate)}
                    variant="standard"
                    type="number"
                    name={field.name}
                    component={FormTextField}
                    label={field.label}
                    validate={field.validate}
                    setDirty={setDirty}
                  />}
                />
                }
              </Box>;
            case CODE_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  disabled={field.disabled || (isUpdate && field.disabledOnUpdate)}
                  variant="standard"
                  name={field.name}
                  component={FormTextField}
                  label={field.label}
                  validate={field.validate}
                  setDirty={setDirty}
                  endAdornment={!isUpdate && field.createCodeButton && <IconButton
                    style={{ padding: 0 }}
                    color="secondary"
                    onClick={() => setBarOrProductCodeValue(values, field.name, setFieldValue)}
                  >
                    <Autorenew />
                  </IconButton>}
                />}
              />;
            case COLOR_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  component={ColorPicker}
                  setDirty={setDirty}
                />}
              />;
            case DAY_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  options={DAY_OPTIONS}
                  component={CommonSelectField}
                  setDirty={setDirty}
                />}
              />;
            case VAT_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  options={vatOptions}
                  validate={field.validate}
                  component={CommonSelectField}
                  setDirty={setDirty}
                />}
              />;
            case DICTIONARY_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  options={dictionaries}
                  validate={field.validate}
                  component={CommonSelectField}
                  setDirty={setDirty}
                />}
              />;
            case PRICE_UNIT_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  options={PRICE_UNIT_OPTIONS}
                  component={CommonSelectField}
                  setDirty={setDirty}
                />}
              />;
            case SELECT_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  options={ListDataCategories.includes(field.name)
                    ? setListDataOptionsForSelectFieldType(field, administrationListData, values)
                    : setExtraDataOptionsForSelectFieldType(field, administrationExtraData)}
                  component={CommonSelectField}
                  validate={field.validate}
                  setDirty={setDirty}
                />}
              />;
            case MULTI_SELECT_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  options={setExtraDataOptionsForSelectFieldType({ name: 'CategoryName' }, administrationExtraData)}
                  component={CommonMultiSelectField}
                  validate={field.validate}
                  setDirty={setDirty}
                  disabled={field.disabled}
                />}
              />;
            case DATE_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  component={DatePicker}
                  setDirty={setDirty}
                />}
              />;
            case  DATE_TIME_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  withTime
                  name={field.name}
                  label={field.label}
                  component={DatePicker}
                  disabled={field.disabled}
                />}
              />;
            case TIME_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  name={field.name}
                  label={field.label}
                  component={TimePicker}
                />}
              />;
            case BOOLEAN_FIELD_TYPE:
              return <FieldWithTooltip
                key={index2}
                helperText={field.helperText}
                formField={<FastField
                  center
                  name={field.name}
                  label={field.label}
                  component={CommonCheckbox}
                  setDirty={setDirty}
                  disabled={field.disabledOnUpdate}
                />}
              />;
          }
        })}
      </div>);
    }));
};

AdministrationItemsFormFields.propTypes = {
  values: PropTypes.object,
  rows: PropTypes.array,
  classes: PropTypes.object,
  administrationExtraData: PropTypes.object,
  administrationListData: PropTypes.object,
  setFieldValue: PropTypes.func,
  isUpdate: PropTypes.bool,
  vatOptions: PropTypes.array,
  dictionaries: PropTypes.array,
  setDirty: PropTypes.func,
  itemIndex: PropTypes.number,
  accordion: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  setAccordion: PropTypes.func,
};

export default AdministrationItemsFormFields;